<template>
  <Base icon="mdi-gender-male-female" :satisfied="requirement.satisfied" tooltip>
    <span>
      {{ requirement.negative ? 'No' : '' }}
      {{ requirement.value }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not identify' : 'identify' }} as
      {{ requirement.value }}
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
